module.exports = __webpack_public_path__ + "img/2015_1.d42263a6.webp";